module.exports = __webpack_public_path__ + "static/img/lucky_draw_banner_cn@2x.cbaa444.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/lucky_draw_banner_cn@2x.png
// module id = kCR6
// module chunks = 1